import React, { useEffect, useRef, useState } from 'react';
import { Button, Container, Form, Image, Spinner } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { Link, useSearchParams } from 'react-router-dom';
import { ASSET_URL } from '../../constant';
import Services from '../../service';


const SearchBar = (props) => {
    const navigate = props.navigate;
    const [searchParams] = useSearchParams();

    let query = searchParams.get('q');

    const refForm = useRef();
    const refSuggestion = useRef();

    const [LoadData, setLoadData] = useState(false)
    const [Search, setSearch] = useState('')
    const [hideSuggestions, setHideSuggestions] = useState(true);

    const [SuggestionData, setSuggestionData] = useState([])

    useEffect(() => {
        if (Search === '') {
            setSuggestionData([])
        }
    }, [Search])

    useEffect(() => {
        setSuggestionData([])
        setSearch('')
        setHideSuggestions(true);
    }, [props.path, query])

    useEffect(() => {
        if (!hideSuggestions) {
            refForm.current.focus()
        }
    }, [hideSuggestions])

    useEffect(() => {
        document.addEventListener("mousedown", function (e) {
            if (refSuggestion.current && !refSuggestion.current.contains(e.target) ) {
                setHideSuggestions(true)
            }
        });
    }, [refSuggestion])

    const handleFocus = () => {
        setHideSuggestions(false)
    };

    const OnChangeSearch = (value) => {
        let limit = 5;
        setSearch(value)

        setLoadData(true)
        setTimeout(() => {
            Services.Search(value)
            .then((res) => {
                setLoadData(false)

                if (value !== '') {
                    setSuggestionData(res.data.products.slice(0, limit))
                } else {
                    setSuggestionData([])
                }

            }).catch((err) => {
                setLoadData(false)
                console.log('error search:', err.response.data)
            })
        }, 350);

    }

    const submitSearch = (e) => {
        e.preventDefault()

        navigate(`/search?q=${Search}`)
    }

    const RecommedSearch = (data) => {
        return (
            <div className={`suggestionsContainer ${hideSuggestions && 'hidden'}`} ref={refSuggestion}>

                {LoadData && <Spinner animation="border" variant="primary" size="sm" />}
                
                {data.length == 0 ? 
                    <p className="m-3">We couldn’t find any products...</p>
                    :
                    <div>
                        <div className="my-3">
                            <p className="my-3 fst-italic">Top Result for "{Search}"</p>
                            <Link to={`/search?q=${Search}`} className="text-primary fw-bold">
                                <FaSearch/> See More Product For "{Search}"
                            </Link>
                        </div>
                        {
                            data.map((d, i) => (
                                <Link to={'/products/'+ d.item_no} className="suggestion text-dark" key={i}>
                                    <div className="thumb">
                                        <Image  variant="top" src={ASSET_URL + JSON.parse(d.image)[0].url} className="rounded-0 w-100" />
                                    </div>
                                    <div className="ms-2">
                                        <p className="m-0 fw-bold text-uppercase">{d.name}</p>
                                        <div className="d-flex align-items-center gap-2">
                                            <p className="text-secondary m-0 small">MI ITEM # {d.item_no}</p>
                                            <p className="text-secondary m-0 small">|</p>
                                            <p className="text-secondary m-0 small">MFR # {d.manufacture_no}</p>
                                        </div>
                                    </div>
                                </Link>
                            ))
                        }
                    </div>
                }
            </div>
        )
    }


    return (
        <Container className="position-relative">
            <Form as={'div'}>
                <Form.Group className="input-group my-2 my-lg-0">
                    <Form.Control type="text" className="search-form"
                        ref={refForm}
                        onFocus={handleFocus}
                        name="q"
                        autoComplete="off"
                        value={Search}
                        onChange={(e) => OnChangeSearch(e.target.value)}
                        placeholder="Search by product name or part number..." />
                    <Button type="button" className="form-control btn btn-submit-search" onClick={(e) => submitSearch(e)}>
                        <FaSearch />
                    </Button>
                </Form.Group>
            </Form>
            {RecommedSearch(SuggestionData)}
        </Container>
    )
}

export default SearchBar
